import test from "./src/test.vue";
// 支持按需引用
test.install = function (Vue) {
  Vue.component(test.name, test);
};
export default test;
